export enum AdServerAdapterKey {
    GAM = "GAM",
    TagManager = "TagManager",
    SAS = "SAS",
    AppNexus = "AppNexus"
}
